import { NumberInput } from '@angular/cdk/coercion';
import { Component, computed, input, numberAttribute } from '@angular/core';
import { Options } from 'highcharts';
import {
  HighchartsChartComponent,
  providePartialHighcharts,
} from 'highcharts-angular';

@Component({
  selector: 'procure-radar-chart',
  templateUrl: './radar-chart.component.html',
  styleUrl: './radar-chart.component.scss',
  imports: [HighchartsChartComponent],
  providers: [
    providePartialHighcharts({
      modules: () => [import('highcharts/esm/highcharts-more')],
    }),
  ],
})
export class RadarChart {
  readonly dataset = input.required<number[]>();
  readonly categories = input.required<string[]>();
  readonly min = input<number>(0);
  readonly max = input<number, NumberInput>(10, { transform: numberAttribute });
  readonly tickInterval = input<number>(2);

  // eslint-disable-next-line max-lines-per-function
  readonly chartOptions = computed<Options>(() => ({
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    chart: {
      polar: true,
      type: 'line',
    },
    pane: {
      size: '80%',
    },
    xAxis: {
      categories: this.categories(),
      tickmarkPlacement: 'on',
      lineWidth: 0,
    },
    yAxis: {
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      tickInterval: 2,
      min: this.min(),
      max: this.max(),
    },
    tooltip: {
      shared: true,
      headerFormat:
        '<span style="font-size: 14px"><b>{point.key}</b></span><br/>',
      pointFormat:
        '<span style="color:{series.color}">{series.name}: {point.y:,.0f}<br/>',
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        type: 'area',
        name: 'Value',
        data: this.dataset(),
        pointPlacement: 'on',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            pane: {
              size: '70%',
            },
          },
        },
      ],
    },
  }));
}
